<template>
  <div id="app">
    <b-navbar sticky toggleable="sm" type="dark" variant="dark">
      <!-- <b-navbar-nav> -->
      <b-navbar-brand class="brand" to="/">
        <b-img height="100" :src="require('./assets/company-logos/transparent-logo.png')"></b-img>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <!-- <b-nav-item class="page" to="/career">Career</b-nav-item>
          <b-nav-item class="page" to="/projects">Projects</b-nav-item>-->
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item
            href="https://www.facebook.com/CLRcarpentry/"
            target="_blank"
            v-b-tooltip
            title="Facebook"
          >
            <b-img height="50" :src="require('./assets/icons/facebook.png')"></b-img>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  /* color: #2c3e50; */
  color: white;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
.brand {
  font-weight: bold;
  font-size: 4em;
}

.page {
  font-size: 1.5em;
}
</style>